import closeIcon from '@/assets/svg/closeIcon.svg'
import clsx from 'clsx'
import Link from 'next/link'

import { MapMarker } from '@/features/product/choose-pickup-point/assets/MapMarker'
import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { formatDate } from '@/shared/lib/utils/date/format-date'
import { isToday } from '@/shared/lib/utils/date/is-today'
import { Icon } from '@/shared/ui/icon'

import cls from './MapBalloon.module.scss'

const calcDeliveryDateString = (deliveryDate: string) => {
	return isToday(deliveryDate) ? 'сегодня' : formatDate(deliveryDate)
}

type BalloonProps = {
	shop: Shop
	isVisible?: boolean
	fastOrderLink?: string
}

export const MapBalloon = ({ shop, isVisible, fastOrderLink }: BalloonProps): JSX.Element => {
	const isDesktop = typeof window !== 'undefined' && window.matchMedia('(min-width: 992px)').matches
	const { NAME, METRO_LINE, METRO, FULL_ADDRESS, DELIVERY_DATE, SCHEDULE, STORE_ID } = shop
	const isAvailableToday = DELIVERY_DATE && isToday(DELIVERY_DATE)
	const storeOrderLink = fastOrderLink
		? `${fastOrderLink}${fastOrderLink.includes('?') ? '&' : '?'}store=${STORE_ID}`
		: '#'

	return !isDesktop ? (
		<div className={clsx(cls.mapBalloon, isVisible && cls.mapBalloon_visible)}>
			<Icon icon={closeIcon} height={14} width={14} className={cls.mapBalloon__closeIcon} />
			<p className={cls.mapBalloon__title}>{NAME}</p>
			<div className={cls.mapBalloon__subwayPanel}>
				<span style={{ background: METRO_LINE }} className={cls.mapBalloon__subwayMark} aria-hidden="true" />
				<span className={cls.mapBalloon__subwayName}>{METRO}</span>
			</div>
			<p className={cls.mapBalloon__address}>{FULL_ADDRESS}</p>
			<p className={cls.mapBalloon__sheldue}>{SCHEDULE}</p>
			<p
				className={clsx(cls.mapBalloon__available, {
					[cls.mapBalloon__available__today]: isAvailableToday
				})}>
				{DELIVERY_DATE && `Доступен ${calcDeliveryDateString(DELIVERY_DATE)}`}
			</p>

			<Link prefetch={false} href={storeOrderLink} className={cls.mapBalloon__button}>
				Забронировать
			</Link>

			<MapMarker color="#568DFE" className={cls.mapBalloon__marker} />
		</div>
	) : (
		<></>
	)
}
